"use strict";

require(['jquery'], function ($) {
  var getComputedStyle = document.defaultView && document.defaultView.getComputedStyle,
    rupper = /([A-Z])/g,
    rdashAlpha = /-([a-z])/ig,
    fcamelCase = function fcamelCase(all, letter) {
      return letter.toUpperCase();
    },
    getStyle = function getStyle(elem, noComputed) {
      if (noComputed) {
        return elem.style;
      } else if (getComputedStyle) {
        return getComputedStyle(elem, null);
      } else if (elem.currentStyle) {
        return elem.currentStyle;
      }
    },
    rfloat = /float/i,
    rnumpx = /^-?\d+(?:px)?$/i,
    rnum = /^-?\d/;
  $.styles = function (el, styles, noCompute) {
    if (!el) {
      return null;
    }
    var currentS = getStyle(el, noCompute),
      oldName,
      val,
      style = el.style,
      results = {},
      i = 0,
      left,
      rsLeft,
      camelCase,
      name;
    for (; i < styles.length; i++) {
      name = styles[i];
      oldName = name.replace(rdashAlpha, fcamelCase);
      if (rfloat.test(name)) {
        name = $.support.cssFloat ? "float" : "styleFloat";
        oldName = "cssFloat";
      }
      if (noCompute) {
        results[oldName] = currentS[name];
      } else if (getComputedStyle) {
        name = name.replace(rupper, "-$1").toLowerCase();
        val = currentS.getPropertyValue(name);
        if (name === "opacity" && val === "") {
          val = "1";
        }
        results[oldName] = val;
      } else {
        camelCase = name.replace(rdashAlpha, fcamelCase);
        results[oldName] = currentS[name] || currentS[camelCase];
        if (!rnumpx.test(results[oldName]) && rnum.test(results[oldName])) {
          left = style.left;
          rsLeft = el.runtimeStyle.left;
          el.runtimeStyle.left = el.currentStyle.left;
          style.left = camelCase === "fontSize" ? "1em" : results[oldName] || 0;
          results[oldName] = style.pixelLeft + "px";
          style.left = left;
          el.runtimeStyle.left = rsLeft;
        }
      }
    }
    return results;
  };
  $.fn.styles = function () {
    return $.styles(this[0], $.makeArray(arguments));
  };
  return $;
});

define("evisions/styles", function(){});

